enum OrderItemType {
  STANDARD = "standard",
  PROMOTIONAL = "promotional",
  WARRANTY_REPLACEMENT = "warranty_replacement",
  TRIAL = "trial",
  TESTING = "testing",
}

export default OrderItemType
